import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect, useState } from "react";
import { Marker, TileLayer } from "react-leaflet";
import { useMapEvents } from "react-leaflet/hooks";
import { Box, TextField } from "@mui/material";
import "leaflet/dist/leaflet.css";

export default function ChangeLocation(props) {
  const [markerLatLng, setMarkerLatLng] = useState([35.7009, 51.391241]);
  const [orderDetails, setOrderDetails] = useState();

  useEffect(() => {
    if (props.open.show && props.open.model) {
      setOrderDetails(props.open.model);
      props.setSendNewLoc({
        id: props.open.model.logesticID,
        latitude: props.open.model.latitude,
        longitude: props.open.model.longitude,
      });
      setMarkerLatLng([props.open.model.latitude, props.open.model.longitude]);
    }
  }, [props.open]);

  useEffect(() => {
    if (props.sendNewLoc) {
      setMarkerLatLng([props.sendNewLoc.latitude, props.sendNewLoc.longitude]);
    }
  }, [props.sendNewLoc]);

  // useEffect(() => {
  //   map.setZoom(11);
  // }, [props.sendNewLoc]);

  const map = useMapEvents({
    click: (event) => {
      props.setSendNewLoc({
        ...props.sendNewLoc,
        latitude: event.latlng.lat,
        longitude: event.latlng.lng,
      });

      setMarkerLatLng([event.latlng.lat, event.latlng.lng]);
    },
  });

  L.DomUtil.addClass(map._container, "crosshair-cursor-enabled");

  const myIcon = new L.Icon({
    iconUrl: "/static/img/location-primary-main.svg",
    iconRetinaUrl: "/static/img/location-primary-main.svg",
    popupAnchor: [-0, -0],
    iconSize: [32, 45],
    iconAnchor: [25, 15],
  });

  return (
    <>
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      ></TileLayer>
      <Marker
        // position={[props.sendNewLoc?.latitude, props.sendNewLoc?.longitude]}
        position={markerLatLng ?? []}
        icon={myIcon}
        // icon={L.divIcon({
        //   className: "my-custom-pin",
        //   // popupAnchor: [-0, -0],
        //   // iconSize: [0, 0],
        //   // iconAnchor: [0, 0],
        //   html: `<span style="${markerHtmlStyles}" />`,
        // })}
      ></Marker>
    </>
  );
}
